import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'react-icons-kit'
import { alertTriangle } from 'react-icons-kit/feather/alertTriangle'
import styled from 'styled-components'
import hexToRgba from 'hex-to-rgba'

import { colors } from '../../../utils/constants'
import styles from './InfoBox.module.scss'

/**
* @author
* @function InfoBar
* */

const InfoBoxContainer = styled.div`
	background-color: ${props => props.bgColor};
	border: 0;
	border-style: solid;
	border-color: ${props => props.bgColor};
`

const IconContainer = styled.div`
	color: ${props => props.iconColor};
`

const InfoBar = props => {
	const { type, message, iconColor } = props
	return (
		<InfoBoxContainer
			className={classnames(
				styles.infoBarContainer,
				styles[type.toLowerCase()],
			)}
			bgColor={hexToRgba(colors.otpBlue, '0.9')}
		>
			<IconContainer
				className={styles.iconContainer}
				iconColor={iconColor}
			>
				<Icon icon={alertTriangle} size="3em" />
			</IconContainer>
			<div className={styles.textContainer}>
				<p>
					{message}
				</p>
			</div>
		</InfoBoxContainer>
	)
}

InfoBar.defaultProps = {
	iconColor: '#fff',
}

InfoBar.propTypes = {
	iconColor: PropTypes.string,
	message: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
}

export default InfoBar
